const retryFunction = (fn, retries = 0, ...args) => {
  if (retries < 5) {
    setTimeout(() => fn(...args), 1000);
  }
};

const updateTitle = (title) => {
  const titleEl = document.querySelector('.appstle-portal__mini-hero__title');
  if (titleEl) {
    titleEl.textContent = title;
  }
};

const checkForExistingBanner = () => {
  const bannerEl = document.querySelector(".as-bg-orange-100[role='alert']");
  if (!bannerEl) {
    retryFunction(checkForExistingBanner);
    return;
  }
  const title = bannerEl.querySelector('.as-font-bold').textContent;
  const html = `<p>${bannerEl.querySelector('.as-text-sm').textContent}</p>`;
  renderBanner({ title, html, content: null });
};

const renderBanner = (banner) => {
  const bannerEl = document.createElement('div');
  bannerEl.className = 'appstle-portal__banner';
  bannerEl.role = 'alert';

  const titleEl = document.createElement('p');
  titleEl.className = 'appstle-portal__banner__title';
  titleEl.textContent = banner.title;

  const contentEl = document.createElement('div');
  contentEl.className = 'appstle-portal__banner__content';
  if (banner.content) {
    contentEl.innerHTML = richToHtml(banner.content);
  } else if (banner.html) {
    contentEl.innerHTML = banner.html;
  }

  bannerEl.appendChild(titleEl);
  bannerEl.appendChild(contentEl);

  const heroEl = document.querySelector('.appstle-portal__mini-hero');
  heroEl.appendChild(bannerEl);
};

const addBanner = (banners) => {
  const now = new Date();
  const hour = parseInt(
    now.toLocaleTimeString('en-US', {
      hour: '2-digit',
      hour12: false,
      timeZone: 'America/Los_Angeles',
    })
  );
  const day = parseInt(now.toLocaleDateString('en-US', { day: 'numeric', timeZone: 'America/Los_Angeles' }));
  for (const banner of banners) {
    if (
      (day > banner.first_day && day < banner.last_day) ||
      (day === banner.first_day && hour >= banner.start_hour) ||
      (day === banner.last_day && hour < banner.end_hour)
    ) {
      renderBanner(banner);
      break;
    }
  }
};

const handleUpcomingTab = () => {
  const skipBtn = document.querySelector('.as-skip-order-btn');
  if (!skipBtn) {
    retryFunction(handleUpcomingTab);
    return;
  }
  const firstBottomBtn = document.querySelector(
    '#appstleSubscriptionCustomerPortal .app-main__inner .as-subscription-detail-wrapper .as-button--secondary:not(.as-card .as-button--secondary)'
  );
  if (!firstBottomBtn) {
    retryFunction(handleUpcomingTab);
    return;
  }
  const allstoraSkipBtn = document.querySelector('.allstora-skip-order-btn');
  if (allstoraSkipBtn) {
    return;
  }
  const bottomSkipBtn = document.createElement('button');
  bottomSkipBtn.className = `allstora-skip-order-btn ${firstBottomBtn.className}`;
  bottomSkipBtn.textContent = skipBtn.textContent;
  bottomSkipBtn.addEventListener('click', () => {
    skipBtn.click();
  });
  firstBottomBtn.insertAdjacentElement('beforebegin', bottomSkipBtn);
  skipBtn.style.display = 'none';
};

const handleTabClick = (evt) => {
  if (evt.currentTarget.classList.contains('appstle-subscription-detail-tab')) {
    handleUpcomingTab();
  }
};

const setupTabHandlers = () => {
  const tabs = document.querySelectorAll('.appstle-subscription-detail-tab');
  if (!tabs.length) {
    retryFunction(setupTabHandlers);
    return;
  }
  tabs.forEach((tab) => {
    console.log(tab);
    tab.addEventListener('click', (evt) => handleTabClick(evt));
    if (tab.ariaSelected === 'true') {
      console.log('ACTIVE TAB');
      handleTabClick({ currentTarget: tab });
    }
  });
};

const setupDetailsHandler = (settings) => {
  const detailsBtn = document.querySelectorAll('.as-see-more-link');
  if (!detailsBtn.length) {
    retryFunction(setupDetailsHandler, 0, settings);
    return;
  }
  detailsBtn.forEach((btn) => {
    btn.addEventListener('click', () => {
      setupSubscriptionDetailPage(settings);
    });
  });
};

const setupGoBackHandler = (settings) => {
  const goBackBtn = document.querySelectorAll('.appstle_contract_see_more[href="#/subscriptions/list"]');
  if (!goBackBtn.length) {
    retryFunction(setupGoBackHandler, 0, settings);
    return;
  }
  goBackBtn.forEach((btn) => {
    btn.addEventListener('click', () => {
      setupSubscriptionListPage(settings);
    });
  });
};

const setupSubscriptionListPage = (settings) => {
  updateTitle(settings?.page_title_subscription_list ?? 'My Book Clubs');
  setupDetailsHandler(settings);
};

const setupSubscriptionDetailPage = (settings) => {
  updateTitle(settings?.page_title_subscription_details ?? 'Subscription Details');
  setupTabHandlers();
  setupGoBackHandler(settings);
};

window.addEventListener('DOMContentLoaded', () => {
  if (!window.location.pathname.startsWith('/apps/subscriptions')) {
    return;
  }

  const settings = window.Allstora?.appstle?.overrides;
  const banners = window.Allstora?.appstle?.banners;

  checkForExistingBanner();
  if (banners?.length) {
    addBanner(banners);
  }

  if (/\/subscriptions\/\d+\/detail$/.test(window.location.hash)) {
    setupSubscriptionDetailPage(settings);
  } else if (window.location.pathname.endsWith('/apps/subscriptions') || window.location.hash.endsWith('/subscriptions/list')) {
    setupSubscriptionListPage(settings);
  } else {
    updateTitle(settings?.page_title_fallback ?? 'Subscriber Portal');
  }
});
